const ALFA_BANK_BNK_CMS = 'ALFA_BANK_BNK_CMS';
const MODULE_BANK_BNK_CMS = 'MODULE_BANK_BNK_CMS';
const TOCHKA_BANK_BNK_CMS = 'TOCHKA_BANK_BNK_CMS';
const SBERBANK_BNK_CMS = 'SBERBANK_BNK_CMS';
const TINKOFF_BANK_BNK_CMS = 'TINKOFF_BANK_BNK_CMS';
const OPEN_BANK_BNK_CMS = 'OPEN_BANK_BNK_CMS';
const URALSIB_BNK_CMS = 'URALSIB_BNK_CMS';
const VTB_BANK_CMS = 'VTB_BANK_CMS';
const integrationHelpLinks = {
	[ALFA_BANK_BNK_CMS]: 'https://seeneco.com/help/accounting/#alfa-integration',
	[MODULE_BANK_BNK_CMS]: 'https://seeneco.com/help/accounting/#modul-integration',
	[TOCHKA_BANK_BNK_CMS]: 'https://seeneco.com/help/accounting/#tochka-integration',
	[SBERBANK_BNK_CMS]: 'https://seeneco.com/help/accounting/#sberbank-integration',
	[TINKOFF_BANK_BNK_CMS]: 'https://seeneco.com/help/accounting/#tinkoff-integration',
	[OPEN_BANK_BNK_CMS]: 'https://seeneco.com/help/accounting/',
	[URALSIB_BNK_CMS]: 'https://seeneco.com/help/accounting/',
	[VTB_BANK_CMS]: 'https://seeneco.com/help/accounting/',
};
const rangedCmsNamesList = [
	SBERBANK_BNK_CMS,
	VTB_BANK_CMS,
	ALFA_BANK_BNK_CMS,
	OPEN_BANK_BNK_CMS,
	TINKOFF_BANK_BNK_CMS,
	TOCHKA_BANK_BNK_CMS,
	MODULE_BANK_BNK_CMS,
	URALSIB_BNK_CMS,
];
const rangeCmsNamesMap = rangedCmsNamesList.reduce((acc, v, idx) => (acc[v] = idx, acc), {});
const CMSNamesMap = {
	[MODULE_BANK_BNK_CMS]: 'Модульбанк',
	[ALFA_BANK_BNK_CMS]: 'Альфабанк',
	[TOCHKA_BANK_BNK_CMS]: 'Точка Банк',
	[TINKOFF_BANK_BNK_CMS]: 'Тинькофф Банк',
	[SBERBANK_BNK_CMS]: 'Сбербанк',
	[URALSIB_BNK_CMS]: 'Уралсиб банк',
	[OPEN_BANK_BNK_CMS]: 'Открытие банк',
	[VTB_BANK_CMS]: 'ВТБ банк',
};

export {
	ALFA_BANK_BNK_CMS,
	MODULE_BANK_BNK_CMS,
	TOCHKA_BANK_BNK_CMS,
	SBERBANK_BNK_CMS,
	TINKOFF_BANK_BNK_CMS,
	OPEN_BANK_BNK_CMS,
	URALSIB_BNK_CMS,
	integrationHelpLinks,
	rangedCmsNamesList,
	rangeCmsNamesMap,
	CMSNamesMap,
};
